import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CurrencyDTO, PlaybackScheduleSlotFullDTO } from '../../services/api/api';
import { UtilService } from '../../services/util.service';
import { ModalNavigationComponent } from '../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-pricing-modal',
  templateUrl: './sb-pricing-modal.component.html',
  styleUrls: ['./sb-pricing-modal.component.scss'],
  standalone: false,
})
export class SbPricingModalComponent implements OnInit, ModalNavigationComponent {
  slot: PlaybackScheduleSlotFullDTO;
  isInModalContext: boolean;

  formBudget = new UntypedFormGroup({
    Currency: new UntypedFormControl({ value: undefined, disabled: true }, []),
    MinCPM: new UntypedFormControl({ value: undefined, disabled: true }, []),
    MinCPMDuration: new UntypedFormControl({ value: 10, disabled: true }, []),
    MinCPS: new UntypedFormControl({ value: undefined, disabled: true }, []),
  });
  disabled: any;

  constructor(
    public util: UtilService,
    public modal: ModalNavigationService
  ) {}

  get BudgetCurrency() {
    return this.formBudget.get('Currency');
  }

  get BudgetMinCPM() {
    return this.formBudget.get('MinCPM');
  }

  get BudgetMinCPMDuration() {
    return this.formBudget.get('MinCPMDuration');
  }

  get BudgetMinCPS() {
    return this.formBudget.get('MinCPS');
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.BudgetCurrency.setValue(this.util.defaultCurrency);
      this.slot = this.modal.getCurrentNavigation().data.slot;
      this.disabled = this.modal.getCurrentNavigation().data.disabled;
      if (this.slot && this.disabled !== undefined && this.disabled !== null) {
        this.setDisabled();
        this.updateForm();
        this.registerFormChangesListener();
      }
    }
  }

  clearForm() {
    this.BudgetCurrency.setValue(undefined);
    this.BudgetMinCPM.setValue(undefined);
    this.BudgetMinCPMDuration.setValue(undefined);
    this.BudgetMinCPS.setValue(undefined);
    this.closeModal(true);
  }

  private registerFormChangesListener() {
    this.BudgetCurrency.valueChanges.subscribe(value => {
      let realValue: CurrencyDTO = value ? JSON.parse(decodeURIComponent(value)) : value;
      if (value) {
        for (const currency of this.util.currencies) {
          if (currency.code === realValue.code && currency.name === realValue.name && currency.symbol === realValue.symbol) {
            realValue = currency;
            break;
          }
        }
      }
      this.BudgetCurrency.setValue(realValue, { emitEvent: false });
      if (this.slot) {
        this.slot.currency = realValue;
      }
    });
    this.BudgetMinCPM.valueChanges.subscribe(value => {
      if (this.slot) {
        this.slot.minCPM = value;
      }
    });
    this.BudgetMinCPMDuration.valueChanges.subscribe(value => {
      if (this.slot) {
        this.slot.minCPMDuration = value;
      }
    });
    this.BudgetMinCPS.valueChanges.subscribe(value => {
      if (this.slot) {
        this.slot.minCPS = value;
      }
    });
  }

  private setDisabled() {
    if (this.disabled) {
      this.BudgetCurrency.disable();
      this.BudgetMinCPM.disable();
      this.BudgetMinCPS.disable();
      this.BudgetMinCPMDuration.disable();
    } else {
      this.BudgetCurrency.enable();
      this.BudgetMinCPM.enable();
      this.BudgetMinCPS.enable();
      this.BudgetMinCPMDuration.enable();
    }
  }

  private updateForm() {
    this.BudgetCurrency.setValue(this.slot.currency);
    this.BudgetMinCPM.setValue(this.slot.minCPM);
    this.BudgetMinCPS.setValue(this.slot.minCPS);
    this.BudgetMinCPMDuration.setValue(this.slot.minCPMDuration);

    if (!this.BudgetCurrency.value) {
      this.BudgetCurrency.setValue(this.util.defaultCurrency);
    }
  }

  closeModal(apply: boolean) {
    if (apply) {
      if (this.BudgetCurrency.value && !this.slot.currency) {
        this.slot.currency = this.BudgetCurrency.value;
      }
      this.modal.result(this.slot);
    } else {
      this.modal.result(null);
    }
  }

  getBudgetSubmission(): boolean {
    return !((this.BudgetMinCPMDuration.value && this.BudgetMinCPM.value) || this.BudgetMinCPS.value);
  }
}
